import { render, staticRenderFns } from "./check_srt_form.vue?vue&type=template&id=652b2467"
import script from "./check_srt_form.vue?vue&type=script&lang=js"
export * from "./check_srt_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports